import { BaseDto } from './base.dto';
import { ProductDto } from './product.dto';

export class MenuCategoryItemDto extends BaseDto {
  id: number;
  startDate: Date;
  endDate: Date;
  product: ProductDto;
  colorCode: string;
  sequence?: number;
}
